module.exports = __webpack_public_path__ + "static/media/sign.5a1c60d2.svg";